export const LONG_LANGS = ["ta"];